import React from 'react';

export default () => <div>billings</div>;
